import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface FlyerUploadExpectedProps extends BaseTemplateProps {
  retailerName: string
}

export const FlyerUploadExpectedNotReceived: TemplateDefinition<FlyerUploadExpectedProps> = {
  renderParams: (props: FlyerUploadExpectedProps) => ({
    messageKey: 'notificationsDomain.templates.flyerUploadExpectedNotReceived',
    values: {
      retailerName: props.retailerName,
    },
  }),
}
